<template>
    <vue-easy-lightbox
        :imgs="images"
        :index="index"
        :visible="zooming"
        @hide="() => zooming = !zooming"
    >
        <template v-slot:toolbar="{ toolbarMethods }">
            <div class="vel-toolbar bg-blue">
                <v-btn color="blue" @click="toolbarMethods.zoomIn">
                    <img src="images/zoom-in.png" class="q-pa-sm" style="width: 25px;">
                </v-btn>
                <v-btn color="blue" @click="toolbarMethods.zoomOut">
                    <img src="images/zoom-out.png" class="q-pa-sm" style="width: 25px;">
                </v-btn>
            </div>
        </template>
    </vue-easy-lightbox>
</template>

<script lang="ts" src="./ImageZoomOverlay.ts" />